interface LinearProgressBarProps {
  value: number;
}

const LinearProgressBar = (props: LinearProgressBarProps) => {
  const { value } = props;
  return (
    <div className="relative w-full h-5 bg-blue-100">
      <div
        className="bg-blue-500 h-5 transition-all duration-500"
        style={{ width: `${value}%` }}
      ></div>
      <div className="absolute top-0 left-0 h-10 w-px bg-black" style={{ left: `${value}%` }}></div>

      <div className="absolute top-0 left-full h-10 w-px bg-black -translate-y-2/4"></div>
    </div>
  );
};

export default LinearProgressBar;
